import * as actionTypes from '../actions/actionTypes';
import {updateObject} from "../../utility";

const initialState = {
    error: null,
    status: null,
    loading: false,
    redirect: false
};

const forgotPasswordStart = (state, action) => {
    return updateObject(state, {loading: true, error: null, status: null})
};

const forgotPasswordSuccess = (state, action) => {
    return updateObject(state, {
        error: null,
        loading: false,
        redirect: true,
        status: "If the email address you provided matches our records you will receive an email with a link to reset your password. If you do not receive the email please contact Xosphere Support at support@xosphere.io."
    })
};

const forgotPasswordFail = (state, action) => {
    return updateObject(state, {
            error: action.error,
            loading: false,
            redirect: false,
            status: null,
        }
    )
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FORGOT_PASSWORD_START: return forgotPasswordStart(state, action);
        case actionTypes.FORGOT_PASSWORD_SUCCESS: return forgotPasswordSuccess(state, action);
        case actionTypes.FORGOT_PASSWORD_FAIL: return forgotPasswordFail(state, action);
        default: return state;
    }
};

export default reducer;